import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch, useSelector } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { POSTSUPPORT_TICKET } from "../../config/ApisCollection";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SupportForm() {
  const { profileDetails } = useSelector((state) => state.webUtilities);
  const [userName, setUserName] = useState("");
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [userAge, setUserAge] = useState("");
  const [height, setHeight] = useState("");
  const [goal, setGoal] = useState("");
  const [goalDate, setGoalDate] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [continueBtn, setContinueBtn] = useState(false);
  const accessToken = secureLocalStorage.getItem("accessToken");
  const validateEmail = (email) => {
    // Regular expression for validating email addresses
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    let newErrorMsg = { ...errorMsg }; // Copying the current error message state
    setContinueBtn(true);

    switch (name) {
      case "email":
        if (validateEmail(value)) {
          setEmail(value);
        } else {
          setContinueBtn(false);
          newErrorMsg.email = "Please enter a valid email address.";
        }
        break;
      case "description":
        if (value.length < 50) {
          newErrorMsg.email = "Description must be 50 characters long.";

          setContinueBtn(false);
        } else if (value.length > 250) {
          newErrorMsg.email =
            "Description should not more than 250 characters long ";

          setContinueBtn(false);
        } else {
          setContinueBtn(true);
        }
        setDescription(value);
        break;
      case "name":
        setUserName(value.replace(/[^a-zA-Z\s]/g, "")); // Allow only alphabets and spaces
        if (/\d/.test(value)) {
          newErrorMsg.userName = "First Name should not contain numbers.";
          setContinueBtn(false);
        } else {
          newErrorMsg.userName = null;
        }
        break;
      default:
        break;
    }
    if (userName.length == 0 || email.length == 0) {
      setContinueBtn(false);
    }
    setErrorMsg(newErrorMsg); // Updating the error message state
  };

  const handleGoAHead = async () => {
    let newErrorMsg = { ...errorMsg }; // Copying the current error message state
    // Check if First Name is empty
    if (!userName.trim()) {
      newErrorMsg.userName = "Name is required.";
      toast.warning(newErrorMsg.userName);
      return false;
    } else {
      newErrorMsg.userName = null; // Clear the error message if First Name is not empty
    }
    if (!email.trim()) {
      newErrorMsg.email = "Email is required.";
      toast.warning(newErrorMsg.email);
      return false;
    } else {
      newErrorMsg.email = null; // Clear the error message if First Name is not empty
    }

    if (!description.trim() && description.length <= 50) {
      newErrorMsg.description = "Description must be 50 characters long.";
      toast.warning(newErrorMsg.description);
      return false;
    } else {
      newErrorMsg.description = null; // Clear the error message if First Name is not empty
    }

    setErrorMsg(newErrorMsg); // Updating the error message state

    // If there are no errors, proceed with form submission
    if (!newErrorMsg.userName && !newErrorMsg.email) {
      let data = {
        // userName: userName,
        description: description,
      };
      const headers = {
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json",
        },
      };

      try {
        const response = await axios.post(POSTSUPPORT_TICKET, data, headers);
        if (response.data.status === 200) {
          toast.success(response.data.message);
        } else {
          toast.error("Request failed");
        }
      } catch (error) {
        console.log(error);
        toast.error("Request failed");
      }
    }
  };
  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(1));
  };

  useEffect(() => {
    if (profileDetails) {
      setUserName(profileDetails?.name);
      setEmail(profileDetails?.email);
      setDescription("");
      setHeight("5 ' 7\"");
      setUserAge("25");
      setGoal("Vacation");
      setGoalDate("25 Nov 2023");
    }
  }, [profileDetails]);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      <div className="bodyly spwok pb-8 gap-6 flex flex-col justify-between">
        <ToastContainer position="top-right" />
        <div className="profileinfo px-8">
          <div className="my-2 mb-1">
            <span className="text-sm ml-1 font-semibold text-black">
              Your name
            </span>
            <input
              type="text"
              placeholder="Enter Name"
              name="name"
              onChange={handleChange}
              value={userName || ""}
              className="inputbox text-xs mt-1 border border-gray-300 focus:border-[#FF9950] focus:border focus:outline-none"
            />
          </div>
          <div className="my-2 mb-1">
            <span className="text-sm ml-1 font-semibold text-black">
              Your Email
            </span>
            <input
              type="email"
              placeholder="Enter Email"
              name="email"
              onChange={handleChange}
              value={email || ""}
              className="inputbox text-xs mt-1 border border-gray-300 focus:border-[#FF9950] focus:border focus:outline-none"
            />
          </div>
          <div className="my-2 mb-1">
            <span className="text-sm ml-1 font-semibold text-black">
              Description
            </span>
            <textarea
              className="inputbox text-xs mt-1 border border-gray-300 focus:border-[#FF9950] focus:border focus:outline-none"
              placeholder="Enter your support query...."
              name="description"
              onChange={handleChange}
              rows={15}
            >
              {description || ""}
            </textarea>
            <div className="flex justify-between text-xs text-gray-500 text-right">
              <span>
                Character should be between :- {description?.length}/50-250
              </span>{" "}
              {/* Display the live character count */}
            </div>
          </div>
        </div>

        {continueBtn && (
          <button
            onClick={handleGoAHead}
            className="text-center w-10/12 mx-auto cursor-pointer bg-[#FF9950] py-3.5 rounded-xl"
          >
            <p className="text-lg  font-medium text-[#fff]">Begin chat</p>
          </button>
        )}
      </div>
    </div>
  );
}
